import { render, staticRenderFns } from "./FavoritesManage.vue?vue&type=template&id=d9b96b6c&"
import script from "./FavoritesManage.vue?vue&type=script&lang=ts&"
export * from "./FavoritesManage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports